module.exports = __webpack_public_path__ + "img/futureWill2.b72821c3.png";